import { Component, Input, OnChanges, OnInit } from '@angular/core';

@Component({
  selector: 'pp-account-settings-placeholder-paragraph',
  templateUrl: './account-settings-placeholder-paragraph.component.html',
  styleUrls: ['./account-settings-placeholder-paragraph.component.scss'],
  standalone: false,
})
export class AccountSettingsPlaceholderParagraphComponent implements OnInit, OnChanges {
  @Input() ppNumberOfLines = 2;
  @Input() ppShowEndElement = true;

  linesArray: number[];

  ngOnInit(): void {
    this.fillLinesArray();
  }

  ngOnChanges(): void {
    this.fillLinesArray();
  }

  private fillLinesArray(): void {
    this.linesArray = Array.from({ length: this.ppNumberOfLines }, (_, index) => index);
  }
}
